import React from 'react';
import { Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/WarningRounded';
import { Popover, Whisper } from 'rsuite';

/**
 * @param {{ tooltipWarnings: string[], placement: string?, colorHex: string?, maxWidth?: number }} param0 
 */
const WarningIconWithTooltip = ({ tooltipWarnings, placement = 'top', colorHex = '#ffcc00', maxWidth }) => {
    const popoverContent = (
        <Popover style={{ zIndex: 1500, ...(maxWidth && { maxWidth })  }}>
            {tooltipWarnings.map((warning, index) => (
                <Typography key={index}>
                    {warning}
                </Typography>
            ))}
        </Popover>
    );
    return (
        <Whisper
            speaker={popoverContent}
            placement={placement}
            preventOverflow
        >
            <WarningIcon
                fontSize='larger'
                style={{color : colorHex}}/>
        </Whisper>
    );
}

export default WarningIconWithTooltip;